/** Created by azhou on 2019/2/25.*/
<template>
    <div class="text-left pt-2 pb-2 pl-3 pr-3">
        <!--管理员用户-->
      <div v-if="isAdmin" class="d-center-start">
        <!--菜单伸缩-->
        <div class="d-center mt-1">
          <i class="iconfont icon-caidanzhankai" :class="{'rotate-180':isCollapse}" @click="isCollapseShow"></i>
          <span class="identity">{{userInfo.cn}}账户</span>  
        </div>
        <div class="mt-2 mr-2 d-center">
          <p class="mr-2">自动审核订单</p>
          <el-switch
              v-model="switchs"
              @change="automaticSwitch"
              inactive-text="">
          </el-switch>
        </div>
        <!--用户功能-->
        <el-tooltip effect="dark" :content="item.content" placement="bottom"  :key="item.iconfont" v-for="item in toolTips">
          <i class="iconfont cursor-poin" :class="[ item.iconfont, {'text-size': item.size} ]" @click="$router.push(item.link)">
            <span class="text-xiaoxi" v-if="item.iconfont==='icon-xiaoxi1'&&unReadMsg>0">{{ unReadMsg }}</span>
          </i>
        </el-tooltip>
        <!--用户头像-->
        <el-dropdown @command="handleCommand">
          <div class="avatar">
            <img :src="userHeadInfo.avatar ? ImgPreUrl+ userHeadInfo.avatar : '/images/avatar/avatar_0.png'">
            <p>{{userLoginMessage.truename}}</p>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1"><i class="iconfont icon-geren drop-icon"></i>修改密码</el-dropdown-item>
            <!-- <el-dropdown-item command="2"><i class="iconfont icon-xiugai3 drop-icon"></i>修改名称</el-dropdown-item> -->
            <el-dropdown-item command="3"><i class="iconfont icon-yonghudenglu drop-icon"></i>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!--酒店-企业用户-->
      <div v-else-if="isGroup" class=" d-center-start">
        <!--菜单伸缩-->
        <div class="d-center mt-1">
          <i class="iconfont icon-caidanzhankai" :class="{'rotate-180':isCollapse}" @click="isCollapseShow"></i>
          <span class="identity">{{userInfo.cn}}账户</span>  
        </div>
        <!--用户功能-->
        <el-tooltip effect="dark" :content="item.content" placement="bottom"  :key="item.iconfont" v-for="item in toolTips">
          <i class="iconfont cursor-poin" :class="[ item.iconfont, {'text-size': item.size} ]" @click="$router.push(item.link)">
            <span class="text-xiaoxi" v-if="item.iconfont==='icon-xiaoxi1'&&unReadMsg>0">{{ unReadMsg }}</span>
          </i>
        </el-tooltip>
        <!--用户头像-->
        <el-dropdown @command="handleCommand">
          <div class="avatar isGroupimg">
            <img :src="ImgPreUrl+ userHeadInfo.pic || '/images/avatar/avatar_0.png'" v-if="storeInfo.type==3">
            <img src="/images/public/logo.png" v-if="storeInfo.type==2">
            <p>{{userHeadInfo.title}}</p>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="4"><i class="iconfont icon-icon_edit drop-icon"></i>企业资料</el-dropdown-item>
            <el-dropdown-item command="5" v-if="storeInfo.type==3"><i class="iconfont icon-xiugaitupian drop-icon"></i>门店相册</el-dropdown-item>
            <el-dropdown-item command="3"><i class="iconfont icon-yonghudenglu drop-icon"></i>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!--销售用户-->
      <div v-else-if="!isGroup" class=" d-center-start">
        <!--菜单伸缩-->
        <div class="d-center mt-1">
          <i class="iconfont icon-caidanzhankai" :class="{'rotate-180':isCollapse}" @click="isCollapseShow"></i>
          <span class="identity">{{userInfo.cn}}账户</span>  
        </div>
        <!--客服-->
          <div class="currentHotel" v-if="this.storeInfo.type==3">
            <div class="mr-2">当前企业</div>
            <el-select v-model="storeInfo.storeId" placeholder="请选择操作酒店" @change="onPtions" style="width: 220px" size="small">
              <el-option style="width: 220px" :label="item.title" :value="item.id" :key="item.id" v-for="item in salesAssociationLists.lists"></el-option>
              <el-option label="全部酒店" value="0"></el-option>
            </el-select>
          </div>
                <!--企业认证状态-->
        <div class="cursor-pointer ping-top">
          <el-tooltip effect="dark" content="企业已认证" placement="bottom"   v-if="storeInfo.level==3">
            <img v-lazy="'/images/public/rz_2.png'" height="22px" class="mr-1" alt="企业已认证" />
          </el-tooltip>
          <el-tooltip effect="dark" content="企业未认证" placement="bottom"   v-else>
            <img v-lazy="'/images/public/rz_1.png'" height="22px" class="mr-1" alt="企业未认证" />
          </el-tooltip>
        </div>
        <!--用户功能-->
        <el-tooltip effect="dark" :content="item.content" placement="bottom"  :key="item.iconfont" v-for="item in toolTips">
          <i class="iconfont cursor-poin" :class="[ item.iconfont, {'text-size': item.size} ]" @click="$router.push(item.link)">
            <span class="text-xiaoxi" v-if="item.iconfont==='icon-xiaoxi1'&&unReadMsg>0">{{ unReadMsg }}</span>
          </i>
        </el-tooltip>
        <!--用户头像-->
        <el-dropdown @command="handleCommand">
          <div class="avatar">
            <img :src="userHeadInfo.avatar ? ImgPreUrl+ userHeadInfo.avatar : '/images/avatar/avatar_0.png'">
            <p>{{userHeadInfo.truename}}</p>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1"><i class="iconfont icon-geren drop-icon"></i>修改头像</el-dropdown-item>
            <el-dropdown-item command="2"><i class="iconfont icon-xiugai3 drop-icon"></i>修改名称</el-dropdown-item>
            <el-dropdown-item command="3"><i class="iconfont icon-yonghudenglu drop-icon"></i>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
       <Cropper ref="cropper"></Cropper>
    </div>
</template>

<script>
import { data } from 'jquery';
import { options } from 'numeral';
import { mapState,mapGetters, mapActions,mapMutations} from 'vuex'
import temp from '../Admin/FinancialManage/FinancialStats/EchartStat/temp.vue';
import Cropper from '../../components/Cropper/index.vue';
import { debounce } from "lodash";
  export default {
  components: { temp,Cropper},
    name: 'UserHeader',
    props: {
      isCollapse: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState(['userHeadInfo','userLoginMessage','salesAssociationLists','IndexData']),
      ...mapGetters(['storeInfo','unreadTotal','isGroup','unReadMsg','userInfo','isAdmin']),
      //用户头部icon链接
      toolTips() {
        let isAdminArr = [
          {content:`手机号：${this.userLoginMessage.mobile}`,iconfont:'icon-shouji1'},
          {content:'去订单雨首页',iconfont:'icon-shouye6',link:{name:'index_page'}},
        ]
        if( this.isAdmin){
          return isAdminArr;
        }
        let arr = [
          {content:'实名认证',iconfont:'icon-cedaohang-kehuguanli',size:true,link:{name:'AccountSet',query:{ type:'identity'}}},
          {content:'绑定微信，接收订单通知',iconfont:'icon-a-ziyuan602',link:{name:'AccountSet',query:{type:'wechat'}}},
          {content:'管理绑定手机',iconfont:'icon-shouji1',link:{name:'AccountSet',query:{type:'phone'}}},
          {content:'消息中心',iconfont:'icon-xiaoxi1',size:true,link:{name:'MsgLists',query:{msg_type:'2'}}},
          {content:'去订单雨首页',iconfont:'icon-shouye6',link:{name:'index_page'}},
        ]
        let isGroupArr=[
          {content:'消息中心',iconfont:'icon-xiaoxi1',size:true,link:{name:'MsgLists',query:{msg_type:'2'}}},
          {content:'去订单雨首页',iconfont:'icon-shouye6',link:{name:'index_page'}},
        ];
        if (this.storeInfo.type === 3) isGroupArr.unshift({content:'排行榜',iconfont:'icon-gongnengpaihangbang',link:{name:'GradeManage',query:{}}})
        if (this.storeInfo.type === 3) isGroupArr.unshift({content:`活跃等级 ${this.userHeadInfo.exp_level}级`,iconfont:'icon-yuqingdengji',link:{name:'GradeManage',query:{tab:'levelrules'}}})
        return this.isGroup?isGroupArr:arr;
      },
    },
    //获取用户积分/活跃度信息
    created() {
      //获取供应商酒店活跃度
      if(this.isGroup){
        this.getUserHead();
      }else{
        this.updateInfo();
      }
      //获取个人用户积分
      if(this.storeInfo.type === 3&&this.storeInfo.level==3) {
        //已选中关联酒店为空测重新调取
        if(this.salesAssociationLists.total==0&&this.storeInfo.type==3){
          this.POST_UnionRecordSaleList({data:{},successFun:()=>{}})
        }
      }
    },
    data() {
      return {
        region:0,
        dialogVisible:true,
        switchs:false,           //自动审核订单
        autoOrder:'',
        visible:false,
      }
    },
    watch:{
      IndexData(){
        if(this.IndexData.autoOrder){
          const flag = this.IndexData.autoOrder === 1
          this.switchs = flag
          this.autoOrder = flag
        }
      },
    },
    methods:{
      ...mapActions(['getUserHead','modifyTruename','updateInfo','POST_UnionRecordSaleList']),
      ...mapMutations(['UPDATECURRENTSTORE','UPDATELOGININFO']),
      //切换菜单
      isCollapseShow(){
        this.$emit('isCollapseShow');
      },
      //处理下拉菜单点击事件
      handleCommand(command) {
          switch (command) {
            case '1':
            this.$refs.cropper.showDialogChange();
            break;
          case '2':
            this.changeUserName();
            break;
          case '3':
            this.$emit('logout');
            break;
          case '4':
            this.$router.push({ name: 'StoreBasicInfo' });
            break;
          case '5':
            this.$router.push({ name: 'StoreAlbum' });
            break;
        }
      },
      //修改用户名称
      changeUserName() {
        this.$prompt('请输入新名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^[\u4e00-\u9fa5A-Za-z]{1,16}$/,
          inputErrorMessage: '请填写正确的联系人姓名'
        }).then(({ value }) => {
          this.modifyTruename({
            truename:value
          })
        }).catch(() => {});
      },
      IDetails(id) {
        if(id){
          this.$router.push('/index_hotel/hotel_detail/' +this.storeInfo.storeId);
        }
      },
      //切换酒店或点击全部返回酒店页面
      onPtions(e){
        console.log(e);
        //点击全部清空酒店ID
        if(e==0){
          let userMessage = JSON.parse(window.localStorage.getItem('userLoginMessage') ) || {};
            userMessage.storeId = 0;
           this.UPDATELOGININFO(userMessage)
        }
        else{
          //切换酒店
          let userMessage = JSON.parse(window.localStorage.getItem('userLoginMessage') ) || {};
          userMessage.storeId = e;
          this.UPDATELOGININFO(userMessage);
          this.$router.push({ name: 'CenterIndex' });
          window.location.reload();
        }
      },
      //自动审核订单
       automaticSwitch: debounce(async function(val){
        if(val==this.autoOrder) return;
        let resData = await this.$axios.post('pc/Admin/AutoVerifyOrderSwitch',{})
        if (resData.code === '00000') {
          this.$message.success(val?'自动核审已开启':'自动核审已关闭')
          this.switchs=val;
          this.autoOrder=val;
        }
      }, 500),
    }
  }
</script>
<style lang="scss" scoped>
  .contract-type{
    padding: 3px 8px;
    font-size: 14px;
    margin-left: 10px;
    >.iconfont{font-size: 14px;}
  }
  .purple{
    color:  #B8A6D8;
    margin-left: 5px;
    font-size: 16px
  }
  .los{
    cursor: pointer;
    display: flex;
    img{
      margin-top: 5px;
      margin-left: 4px;
    }
  }
  .cursor-poin{
    position: relative;
    font-size: 14px;
    margin-top: 6px;
    border-left: 1px #eee solid;
    padding:0 10px;
    cursor: pointer;
  }
  .text-size{
    font-size: 17px;
  }
  .text-xiaoxi{
    position: absolute;
    width: 14px;
    height: 14px;
    background-color: red;
    color: #Fff;
    color: #fff;
    top: -6px;
    right: 1px;
    font-size: 10px;
    text-align: center;
    line-height: 14px;
    border-radius: 50px;
    z-index: 4;
  }
  .paihangbang i{
    font-size: 15px;
  }
  .currentHotel{
    margin-left: auto;
    margin-right: 20px;
    display: flex;
    line-height: 30px;
    margin-top: 10px;
  }
  .wechat{
    color: #999;
  }
  .d-center-start{
    display: flex;
    justify-content:flex-end;
  }
  .d-center{
    margin-right: auto;
  }
  .avatar{
    display: flex;
    align-items: center;
    margin-top: 5px;
    cursor: pointer;
    img{
      width: 30px;
      height: 30px;
      border-radius: 50%;
      margin-right: 10px;
    }
    i{
      margin-left: 10px;
    }
  }
  .drop-icon{
    font-size: 13px;
    margin-right: 6px;
  }
  .icon-caidanzhankai{
    color: #464c58;
    transform: rotate(180deg);
    cursor: pointer;
  }
  .identity{
    font-size: 14px;
    margin-left: 14px;
    font-weight: bold;
  }
  .rotate-180{
    transform: rotate(0deg);
  }
  .isGroupimg img{
    border-radius: 6px;
  }
  .ping-top{
    margin-top: 10px;
  }
  .kefu{
    margin-right: auto;
    display: flex;
    margin-top: 4px;
    i{
      font-size: 20px;
      color: var(--smtc-color-primary);
      cursor: pointer;
    }
  }
  .rw-qr{
     img{
      width: 100%;
     }
     p{
      text-align: center;
      font-size: 12px;
      color: #666;
     }
  }
</style>